"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var RootReducer_1 = require("../../app/RootReducer");
var HelpDashboard_1 = require("../../img/model-results/HelpDashboard");
var TestIds_1 = require("../../util/TestIds");
var Utils_1 = require("../../util/Utils");
var Index_1 = require("../base/Index");
var NavigationContext_1 = require("../base/NavigationContext");
var ModelResultConfusionMatrixTable_1 = require("./binomial/ModelResultConfusionMatrixTable");
var ModelResultRocCurveChart_1 = require("./binomial/ModelResultRocCurveChart");
var ModelResultThresholdController_1 = require("./binomial/ModelResultThresholdController");
var ModelResultOutcomePlot_1 = require("./regression/ModelResultOutcomePlot");
var ModelResultQQPlot_1 = require("./regression/ModelResultQQPlot");
var BINARY_ROC_CONTAINER_WIDTH = 580;
var BINARY_ROC_CHART_WIDTH = 548;
var BINARY_THRESHOLD_CONTROLLER_WIDTH = 220;
var BINARY_CONFUSION_MATRIX_CONTAINER_WIDTH = 595;
var BINARY_CONFUSION_MATRIX_TABLE_WIDTH = 563;
var REGRESSION_CHART_CONTAINER_WIDTH = 736;
var REGRESSION_CHART_DIMENSION = 720;
var ModelResultReviewPerformance = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), modelType = _a.type, modelMetrics = _a.modelMetrics;
    var refs = React.useContext(NavigationContext_1.NavigationContext);
    var setNavigationRef = function (node) {
        refs['MODEL_RESULT_REVIEW_PERFORMANCE'] = node;
    };
    if (!modelMetrics || !modelType) {
        return React.createElement(Index_1.Error, { message: Localize_1.Messages.chartErrorMessage(), testId: TestIds_1.MODEL_RESULT_CHART_ERROR_TEST_ID + 'review-performance' });
    }
    var renderBinomialModelContent = function () {
        var modelMetricsValidation = modelMetrics.validation;
        return (React.createElement(React.Fragment, null,
            React.createElement(Index_1.Card, null,
                React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.thresholdSectionText(), width: BINARY_THRESHOLD_CONTROLLER_WIDTH },
                    React.createElement(ModelResultThresholdController_1.default, { confusionMatrices: modelMetricsValidation.confusionMatrices }))),
            React.createElement(Index_1.Card, null,
                React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.thresholdConfusionMatrixTitle(), tooltip: Localize_1.Messages.thresholdConfusionMatrixDescription(), width: BINARY_CONFUSION_MATRIX_CONTAINER_WIDTH },
                    React.createElement(ModelResultConfusionMatrixTable_1.default, { width: BINARY_CONFUSION_MATRIX_TABLE_WIDTH }))),
            React.createElement(Index_1.Card, null,
                React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.thresholdRocCurve(), width: BINARY_ROC_CONTAINER_WIDTH },
                    React.createElement(ModelResultRocCurveChart_1.default, { width: BINARY_ROC_CHART_WIDTH })))));
    };
    var renderRegressionModelContent = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Index_1.Card, null,
                React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.residualPlotTitle(), tooltip: Localize_1.Messages.residualPlotDescription(), width: REGRESSION_CHART_CONTAINER_WIDTH },
                    React.createElement(ModelResultOutcomePlot_1.default, { width: REGRESSION_CHART_DIMENSION }))),
            React.createElement(Index_1.Card, null,
                React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.qqPlotTitle(), tooltip: Localize_1.Messages.qqPlotDescription(), width: REGRESSION_CHART_CONTAINER_WIDTH },
                    React.createElement(ModelResultQQPlot_1.default, { width: REGRESSION_CHART_DIMENSION })))));
    };
    return (React.createElement("div", { ref: setNavigationRef, "data-tb-test-id": TestIds_1.MODEL_RESULT_REVIEW_PERFORMANCE_TEST_ID },
        React.createElement(Index_1.Card.List, { icon: React.createElement(HelpDashboard_1.HelpDashboard, null), title: Localize_1.Messages.modelResultReviewPerformanceTitle(), description: Localize_1.Messages.modelResultReviewPerformanceSubtitle(), expand: true },
            (0, Utils_1.isBinomialModel)(modelType) && renderBinomialModelContent(),
            (0, Utils_1.isRegressionModel)(modelType) && renderRegressionModelContent())));
};
exports.default = ModelResultReviewPerformance;
//# sourceMappingURL=ModelResultReviewPerformance.js.map